// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__HrbJ-","approved":"Status_approved__-ILNF","rejected":"Status_rejected__SPK_e","expired":"Status_expired__2DUqQ","label":"Status_label__QFgwA"};